<template>
  <div class="card">
    <div style="text-align: center">
      <img src="@images/text-logo.png" />
    </div>
    <!-- #F0F8FA -->
    <div class="reg-title">
      欢迎您申请加入天津博物馆志愿者。请确保您提供了完整且准确的资料，以便您能及时收到志愿者信息及获得相应的服务。（以下带<span>*</span>号为必填项）
    </div>
    <hr />
    <div style="height: 20px"></div>
    <div class="flex-s-s" style="width: 1200px; margin: auto">
      <el-form
        ref="form"
        :inline="true"
        :model="form"
        :rules="rules"
        label-width="170px"
        label-suffix=":"
        style="width: calc(100% - 250px); margin-right: 50px"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input placeholder="请输入姓名" v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="form.sex" placeholder="请选择性别">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期" prop="birth">
          <el-date-picker
            type="date"
            placeholder="选择出生日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="form.birth"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="政治面貌" prop="political">
          <el-select v-model="form.political" placeholder="请选择政治面貌">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in politicalList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="idCardType">
          <el-select v-model="form.idCardType" placeholder="请选择证件类型">
            <el-option label="身份证" value="身份证"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="idCard">
          <el-input
            placeholder="请输入证件号码"
            v-model="form.idCard"
          ></el-input>
        </el-form-item>

        <el-form-item label="当前状态" prop="currentStatus">
          <el-select v-model="form.currentStatus" placeholder="请选择当前状态">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in statusList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 新 -->
        <el-form-item label="是否为天津常住居民" prop="isResident">
          <el-select
            v-model="form.isResident"
            placeholder="请选择是否为天津常住居民"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="highestEducation">
          <el-select v-model="form.highestEducation" placeholder="请选择学历">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in eduList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="form-row">
          <el-form-item label="现居住地" prop="homeAddress">
            <el-input
              v-model="form.homeAddress"
              type="textarea"
              placeholder="请输入现居住地"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="工作单位/学校" prop="workUnit">
          <el-input
            placeholder="请输入工作单位/学校"
            v-model="form.workUnit"
          ></el-input>
        </el-form-item>
        <el-form-item label="职务职称" prop="officialCapacity">
          <el-input
            placeholder="请输入职务职称"
            v-model="form.officialCapacity"
          ></el-input>
        </el-form-item>
        <el-form-item label="岗位/专业及年级" prop="mainWork">
          <el-input
            placeholder="请输入岗位/专业及年级"
            v-model="form.mainWork"
          ></el-input>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-select v-model="form.nation" placeholder="请选择民族">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in nationList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宗教信仰">
          <el-select v-model="form.religion" placeholder="请选择宗教信仰">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in religionList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="婚姻状况" prop="maritalStatus">
          <el-select v-model="form.maritalStatus" placeholder="请选择婚姻状况">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in marriageList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请岗位" prop="applyPost">
          <el-select v-model="form.applyPost" placeholder="请选择岗位">
            <el-option label="讲解" value="1"></el-option>
            <el-option label="服务" value="2"></el-option>
            <el-option label="策划" value="3"></el-option>
          </el-select>
        </el-form-item>

        <div class="form-row">
          <el-form-item label="服务时间" prop="serviceTime">
            <ul class="table-ul">
              <li></li>
              <li>星期二</li>
              <li>星期三</li>
              <li>星期四</li>
              <li>星期五</li>
              <li>星期六</li>
              <li>星期日</li>
            </ul>
            <ul class="table-ul">
              <li>上午</li>
              <li
                v-for="(item, index) in timeList"
                v-if="item.time == 'am'"
                :key="index"
              >
                <el-checkbox v-model="item.checked"></el-checkbox>
              </li>
            </ul>
            <ul class="table-ul">
              <li>下午</li>
              <li
                v-for="(item, index) in timeList"
                v-if="item.time == 'pm'"
                :key="index"
              >
                <el-checkbox v-model="item.checked"></el-checkbox>
              </li>
            </ul>
          </el-form-item>
        </div>
        <el-form-item label="联系电话" prop="contactInfo">
          <el-input
            placeholder="请输入联系电话"
            v-model="form.contactInfo"
          ></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="mailbox">
          <el-input
            placeholder="请输入电子邮箱"
            v-model="form.mailbox"
          ></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人" prop="emergencyName">
          <el-input
            placeholder="请输入紧急联系人"
            v-model="form.emergencyName"
          ></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人电话" prop="emergencyPhone">
          <el-input
            placeholder="请输入紧急联系人电话"
            v-model="form.emergencyPhone"
          ></el-input>
        </el-form-item>
        <div class="form-row">
          <el-form-item label="通讯地址" prop="mailAddress">
            <el-input
              placeholder="请输入通讯地址"
              v-model="form.mailAddress"
              type="textarea"
            ></el-input>
          </el-form-item>
        </div>
        <span class="no-red-form-item" v-if="form.applyPost == 1">
          <div class="form-row">
            <el-form-item label="讲解组" prop="explain">
              <ul class="table-ul">
                <li>类型</li>
                <li v-for="(item, index) in explainTypeList" :key="index">
                  <el-checkbox v-model="item.checked">{{
                    item.label
                  }}</el-checkbox>
                </li>
              </ul>
              <ul class="table-ul">
                <li>语法</li>
                <li v-for="(item, index) in explainLanguageList" :key="index">
                  <el-checkbox v-model="item.checked">{{
                    item.label
                  }}</el-checkbox>
                </li>
              </ul>
              <ul class="table-ul">
                <li>使用情况</li>
                <li
                  class="select-li"
                  v-for="(item, index) in explainLanguageUseList"
                  :key="index"
                >
                  <el-select
                    size="small"
                    v-model="item.value"
                    :placeholder="item.placeholder"
                  >
                    <el-option
                      :label="subItem.label"
                      :value="subItem.value"
                      v-for="subItem in item.options"
                      :key="subItem.value"
                    ></el-option>
                  </el-select>
                </li>
              </ul>
              <ul class="table-ul">
                <li>相关文博知识</li>
                <li v-for="(item, index) in otherKnowledgeList" :key="index">
                  <el-radio v-model="form.otherKnowledge" :label="item.value">{{
                    item.label
                  }}</el-radio>
                </li>
              </ul>
            </el-form-item>
          </div>
        </span>

        <div class="form-row" v-if="form.applyPost == 3">
          <el-form-item label="策划组" prop="plan">
            <ul class="table-ul">
              <li>类型</li>
              <li v-for="(item, index) in planTypeList" :key="index">
                <el-checkbox v-model="item.checked">{{
                  item.label
                }}</el-checkbox>
              </li>
            </ul>
            <ul class="table-ul">
              <li>文字工作</li>
              <li v-for="(item, index) in planFuncList" :key="index">
                <div v-for="(i, idx) in item" :key="idx">
                  <el-checkbox v-model="i.checked">{{ i.label }}</el-checkbox>
                </div>
              </li>
            </ul>
            <ul class="table-ul">
              <li>摄影</li>
              <li v-for="(item, index) in planPhotoList" :key="index">
                <el-checkbox v-model="item.checked">{{
                  item.label
                }}</el-checkbox>
              </li>
            </ul>
            <ul class="table-ul">
              <li>图像视频处理</li>
              <li v-for="(item, index) in planPsList" :key="index">
                <el-checkbox v-model="item.checked">{{
                  item.label
                }}</el-checkbox>
              </li>
            </ul>
          </el-form-item>
        </div>

        <div class="form-row" v-if="form.applyPost == 2">
          <el-form-item label="服务组" prop="service">
            <ul class="table-ul">
              <li>类型</li>
              <li v-for="(item, index) in serviceTypeList" :key="index">
                <el-checkbox v-model="item.checked">{{
                  item.label
                }}</el-checkbox>
              </li>
            </ul>
            <ul class="table-ul">
              <li>办公软件</li>
              <li v-for="(item, index) in serviceOfficeList" :key="index">
                <el-checkbox
                  v-for="(i, idx) in item"
                  :key="idx"
                  v-model="i.checked"
                  >{{ i.label }}</el-checkbox
                >
              </li>
            </ul>

            <ul class="table-ul">
              <li>人力管理经验</li>
              <li v-for="(item, index) in serviceExperienceList" :key="index">
                <el-radio v-model="form.hrExperience" :label="item.value">{{
                  item.label
                }}</el-radio>
              </li>
            </ul>
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item label="个人特长" prop="volunteerServiceExperience">
            <el-input
              v-model="form.volunteerServiceExperience"
              type="textarea"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="学习经历" prop="studyAndWorkExperience">
            <el-input
              v-model="form.studyAndWorkExperience"
              type="textarea"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="工作经历" prop="reasonsVolunteerWork">
            <el-input
              v-model="form.reasonsVolunteerWork"
              type="textarea"
            ></el-input>
          </el-form-item>
        </div>

        <!-- <el-form-item label="来馆时间" prop="firstTime">
          <el-date-picker
            v-model="form.firstTime"
            value-format="yyyy"
            format="yyyy"
            type="year"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-form-item>
        -->
        <div class="form-row">
          <el-form-item
            style="display: flex; align-items: center; justify-content: center"
            label=""
          >
            <el-checkbox v-model="ruleRead"> </el-checkbox
            ><span>
              亲爱的朋友，志愿者工作需要你有对社会奉献的爱心与热情、充足的时间及精力，以及相应的工作能力。如果您这一切都已经准备好了，请您在此确认，感谢您对文博事业做出的贡献。</span
            >
          </el-form-item>
        </div>
        <div
          class="form-row"
          style="display: flex; align-items: center; justify-content: center"
        >
          <el-form-item
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            "
          >
            <el-button type="primary" @click="onSubmit('form')">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div style="margin-top: 50px">
        <photo-upload @get-photo="getPhoto" image=""></photo-upload>
        <p style="font-size: 12px; text-align: center; color: @font-grey">
          近半年内一寸免冠照片
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import photoUpload from "@/components/upload/photo-upload.vue";
import gl from "@/api/global";

export default {
  components: {
    photoUpload,
  },
  data() {
    var contactInfoRule = (rule, value, callback) => {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/; //手机号码
      var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/; // 座机格式  区号之后用'-'隔开
      if (isMob.test(value) || isPhone.test(value)) {
        callback();
      } else {
        callback(new Error("联系方式输入有误"));
      }
    };
    var idCardRule = (rule, value, callback) => {
      let code = value;
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 ",
      };
      var tip = "";
      var pass = true;
      if (
        !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          code
        )
      ) {
        tip = "证件号码格式错误!";
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "证件号码地址编码错误!";
        pass = false;
      } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split("");
          //∑(ai×Wi)(mod 11)
          //加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          //校验位
          var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          var sum = 0;
          var ai = 0;
          var wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          var last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            tip = "校验位错误";
            pass = false;
          }
        }
      }
      if (pass) {
        callback();
      } else {
        callback(new Error("证件号码输入有误"));
      }
    };
    var mailboxRule = (rule, value, callback) => {
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        callback();
      } else {
        callback(new Error("请输入合法的邮箱"));
      }
    };

    var explainRule = (rule, value, callback) => {
      let explainTypeFlag = false;
      for (let index = 0; index < this.explainTypeList.length; index++) {
        const element = this.explainTypeList[index];
        if (element.checked) {
          explainTypeFlag = true;
          break;
        }
      }
      if (!explainTypeFlag) {
        callback(new Error("请选择完善讲解组信息"));
      } else {
        callback();
      }
    };

    var planRule = (rule, value, callback) => {
      let planTypeFlag = false;
      for (let index = 0; index < this.planTypeList.length; index++) {
        const element = this.planTypeList[index];
        if (element.checked) {
          planTypeFlag = true;
          break;
        }
      }
      if (!planTypeFlag) {
        callback(new Error("请选择完善策划组信息"));
      } else {
        callback();
      }
    };

    var serviceRule = (rule, value, callback) => {
      let serviceTypeFlag = false;
      for (let index = 0; index < this.serviceTypeList.length; index++) {
        const element = this.serviceTypeList[index];
        if (element.checked) {
          serviceTypeFlag = true;
          break;
        }
      }
      if (!serviceTypeFlag) {
        callback(new Error("请选择完善策划组信息"));
      } else {
        callback();
      }
    };

    return {
      form: {
        regType: "1",
        // teamName: "",
        userName: "",
        sex: "",
        birth: "",
        nation: "",
        religion: "",
        maritalStatus: "",
        political: "",
        idCard: "",
        idCardType: "",
        currentStatus: "",
        workUnit: "",
        officialCapacity: "",
        mainWork: "",
        contactInfo: "",
        mailbox: "",
        emergencyName: "",
        emergencyPhone: "",
        mailAddress: "",
        highestEducation: "",
        homeAddress: "",
        applyPost: "",
        // firstTime: "",
        volunteerServiceExperience: "",
        studyAndWorkExperience: "",
        reasonsVolunteerWork: "",
        // wayText: "",
        photo: "",
        isResident: "",
        otherKnowledge: 0,
        hrExperience: 0,
        serviceTime: "", //仅用于校验
        explain: "", //仅用于校验
        plan: "", //仅用于校验
        service: "", //仅用于校验
      },
      ruleRead: false,
      nationList: [
        { label: "汉族", value: "汉族" },
        { label: "蒙古族", value: "蒙古族" },
        { label: "回族", value: "回族" },
        { label: "藏族", value: "藏族" },
        { label: "维吾尔族", value: "维吾尔族" },
        { label: "苗族", value: "苗族" },
        { label: "彝族", value: "彝族" },
        { label: "壮族", value: "壮族" },
      ],
      politicalList: [
        { label: "中共党员", value: "中共党员" },
        { label: "中共预备党员", value: "中共预备党员" },
        { label: "共青团员", value: "共青团员" },
        { label: "群众", value: "群众" },
        { label: "其他", value: "其他" },
      ],
      statusList: [
        { label: "学生", value: "1" },
        { label: "在职", value: "2" },
        { label: "退休", value: "3" },
        { label: "小志愿者", value: "4" },
      ],
      eduList: [
        { label: "博士研究生", value: "1" },
        { label: "硕士研究生", value: "2" },
        { label: "在职研究生", value: "3" },
        { label: "大学", value: "4" },
        { label: "大专", value: "5" },
        { label: "中专", value: "6" },
        { label: "高中", value: "7" },
        { label: "初中", value: "8" },
        { label: "小学", value: "9" },
        { label: "其他", value: "10" },
      ],
      timeList: [
        { checked: false, day: "1", time: "am" },
        { checked: false, day: "2", time: "am" },
        { checked: false, day: "3", time: "am" },
        { checked: false, day: "4", time: "am" },
        { checked: false, day: "5", time: "am" },
        { checked: false, day: "6", time: "am" },
        { checked: false, day: "7", time: "pm" },
        { checked: false, day: "8", time: "pm" },
        { checked: false, day: "9", time: "pm" },
        { checked: false, day: "10", time: "pm" },
        { checked: false, day: "11", time: "pm" },
        { checked: false, day: "12", time: "pm" },
      ],
      religionList: [
        { label: "无宗教信仰", value: "无宗教信仰" },
        { label: "佛教", value: "佛教" },
        { label: "伊斯兰教", value: "伊斯兰教" },
        { label: "基督教", value: "基督教" },
      ],
      marriageList: [
        { label: "已婚", value: "已婚" },
        { label: "未婚", value: "未婚" },
        { label: "离异", value: "离异" },
        { label: "丧偶", value: "丧偶" },
      ],
      explainTypeList: [
        { label: "文物专题组", value: "文物专题组", checked: false },
        { label: "历史组", value: "历史组", checked: false },
      ],
      explainLanguageList: [
        { label: "普通话", value: "普通话", checked: false, useType: "" },
        { label: "英语", value: "英语", checked: false, useType: "" },
      ],
      explainLanguageUseList: [
        {
          placeholder: "普通话使用情况",
          value: "",
          options: [
            { label: "流利", value: "流利" },
            { label: "一般", value: "一般" },
          ],
        },
        {
          placeholder: "英语使用情况",
          value: "",
          options: [
            { label: "流利", value: "流利" },
            { label: "一般", value: "一般" },
          ],
        },
      ],
      otherKnowledgeList: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      planTypeList: [
        { label: "活动策划", value: "活动策划", checked: false },
        { label: "活动宣传", value: "活动宣传", checked: false },
      ],
      planFuncList: [
        [
          { label: "新闻稿撰写", value: "新闻稿撰写", checked: false },
          { label: "讲解稿撰写", value: "讲解稿撰写", checked: false },
        ],
        [
          { label: "文字编辑", value: "文字编辑", checked: false },
          { label: "公众号运营", value: "公众号运营", checked: false },
        ],
      ],
      planPhotoList: [
        { label: "专业摄影", value: "专业摄影", checked: false },
        { label: "视频录制", value: "视频录制", checked: false },
      ],
      planPsList: [
        { label: "PR/AE", value: "PR/AE", checked: false },
        { label: "Photoshop", value: "Photoshop", checked: false },
      ],
      serviceTypeList: [
        { label: "人事管理", value: "人事管理", checked: false },
        { label: "资料整理", value: "资料整理", checked: false },
      ],
      serviceOfficeList: [
        [
          { label: "Word", value: "Word", checked: false },
          { label: "PPT", value: "PPT", checked: false },
        ],
        [{ label: "Excel", value: "Excel", checked: false }],
      ],
      serviceExperienceList: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      rules: {
        // teamName: [
        //   { required: true, message: "请输入团队名称", trigger: "blur" },
        // ],

        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
        ],
        nation: [{ required: true, message: "请选择民族", trigger: "change" }],
        maritalStatus: [
          { required: true, message: "请选择婚姻状态", trigger: "change" },
        ],
        mailbox: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
          { validator: mailboxRule, trigger: "blur" },
        ],
        emergencyName: [
          { required: true, message: "请输入紧急联系人", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
        ],

        emergencyPhone: [
          { required: true, message: "请输入紧急联系人电话", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
        ],
        mailAddress: [
          { required: true, message: "请输入通讯地址", trigger: "blur" },
          { message: "最多输入200个字符", trigger: "blur", max: 200 },
        ],
        highestEducation: [
          { required: true, message: "请选择学历", trigger: "change" },
        ],
        homeAddress: [
          { required: true, message: "请输入现居住地", trigger: "blur" },
          { message: "最多输入200个字符", trigger: "blur", max: 200 },
        ],

        officialCapacity: [
          { required: true, message: "请输入职务职称", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
        ],
        workUnit: [
          { required: true, message: "请输入工作单位/学校", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
        ],
        mainWork: [{ message: "最多输入20个字符", trigger: "blur", max: 20 }],

        political: [
          { required: true, message: "请选择政治面貌", trigger: "change" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        birth: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        idCard: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
          // { validator: idCardRule, trigger: "blur" },
        ],
        idCardType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],

        currentStatus: [
          { required: true, message: "请选择当前状态", trigger: "change" },
        ],
        applyPost: [
          { required: true, message: "请选择服务岗位", trigger: "change" },
        ],
        contactInfo: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { message: "最多输入20个字符", trigger: "blur", max: 20 },
        ],
        volunteerServiceExperience: [
          { required: true, message: "请输入个人特长", trigger: "blur" },
          { message: "最多输入200个字符", trigger: "blur", max: 200 },
        ],
        studyAndWorkExperience: [
          { required: true, message: "请输入学习经历", trigger: "blur" },
          { message: "最多输入200个字符", trigger: "blur", max: 200 },
        ],
        reasonsVolunteerWork: [
          { required: true, message: "请输入工作经历", trigger: "blur" },
          { message: "最多输入200个字符", trigger: "blur", max: 200 },
        ],
        serviceTime: [
          { required: true, message: "请选择服务时间", trigger: "change" },
        ],

        explain: [{ required: true, validator: explainRule, trigger: "blur" }],
        plan: [{ required: true, validator: planRule, trigger: "blur" }],
        service: [{ required: true, validator: serviceRule, trigger: "blur" }],

        isResident: [
          {
            required: true,
            message: "请选择是否为常住居民",
            trigger: "change",
          },
        ],
      },
      userMess: this.$store.state.user.user,
    };
  },
  computed: {},
  watch: {
    timeList: {
      handler: function (newV, oldV) {
        let serviceList = [];
        newV.map((item) => {
          if (item.checked) {
            serviceList.push(item.day);
          }
        });
        this.form.serviceTime = serviceList.toString();
      },
      deep: true,
    },
    explainTypeList: {
      handler: function (newV, oldV) {
        let explainTypeList = [];
        newV.map((item) => {
          if (item.checked) {
            explainTypeList.push(item.value);
          }
        });
        this.form.explain = explainTypeList.toString();
      },
      deep: true,
    },
    planTypeList: {
      handler: function (newV, oldV) {
        let planTypeList = [];
        newV.map((item) => {
          if (item.checked) {
            planTypeList.push(item.value);
          }
        });
        this.form.plan = planTypeList.toString();
      },
      deep: true,
    },
    serviceTypeList: {
      handler: function (newV, oldV) {
        let serviceTypeList = [];
        newV.map((item) => {
          if (item.checked) {
            serviceTypeList.push(item.value);
          }
        });
        this.form.service = serviceTypeList.toString();
      },
      deep: true,
    },
  },
  methods: {
    onSubmit(formName) {
      if (!(this.form.photo && this.form.photo.length > 0)) {
        this.$message.error("请上传照片");
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleRead) {
            let serviceList = [];
            this.timeList.map((item) => {
              if (item.checked) {
                serviceList.push(item.day);
              }
            });
            let params = {
              applyPost: this.form.applyPost, // 默认有
              birth: this.form.birth,
              contactInfo: this.form.contactInfo,
              currentStatus: this.form.currentStatus,
              // "exhibitionHallId": "string",
              // "exhibitionHallName": "string",
              highestEducation: this.form.highestEducation,
              homeAddress: this.form.homeAddress,
              id: this.$cookies.get("sso_userId"),
              idCard: this.form.idCard,
              idCardType: this.form.idCardType,
              // informationResourceContent: this.form.wayText,
              mailbox: this.form.mailbox,
              emergencyName: this.form.emergencyName,
              emergencyPhone: this.form.emergencyPhone,
              mailAddress: this.form.mailAddress,
              mainWork: this.form.mainWork,
              nation: this.form.nation,
              religion: this.form.religion,
              maritalStatus: this.form.maritalStatus,
              officialCapacity: this.form.officialCapacity,
              photo: this.form.photo,
              political: this.form.political,
              // positiveTime: this.form.firstTime,
              reasonsVolunteerWork: this.form.reasonsVolunteerWork,
              regType: "1",
              serviceTime: serviceList.toString(), //每周可服务时间
              sex: this.form.sex,
              studyAndWorkExperience: this.form.studyAndWorkExperience,
              // teamName: this.form.teamName,
              userName: this.form.userName,
              volunteerServiceExperience: this.form.serviceExperience,
              workUnit: this.form.workUnit,
              isResident: this.form.isResident,
            };
            if (this.form.applyPost == 1) {
              let types = [];
              for (
                let index = 0;
                index < this.explainTypeList.length;
                index++
              ) {
                const element = this.explainTypeList[index];
                if (element.checked) {
                  types.push(element.value);
                }
              }
              let languages = [];
              for (
                let index = 0;
                index < this.explainLanguageList.length;
                index++
              ) {
                const element = this.explainLanguageList[index];
                if (element.checked) {
                  languages.push(element.value);
                }
              }

              for (
                let index = 0;
                index < this.explainLanguageUseList.length;
                index++
              ) {
                const element = this.explainLanguageList[index];
                if (element.checked) {
                  languages.push(element.value);
                }
              }

              let explainGroupContent = {
                englishLevel: this.explainLanguageUseList[1].value,
                languages,
                mandarinLevel: this.explainLanguageUseList[0].value,
                otherKnowledge: this.form.otherKnowledge,
                types,
              };
              params = {
                ...params,
                explainGroupContent,
              };
            }

            if (this.form.applyPost == 3) {
              let types = [];
              for (let index = 0; index < this.planTypeList.length; index++) {
                const element = this.planTypeList[index];
                if (element.checked) {
                  types.push(element.value);
                }
              }
              let writeWorks = [];
              for (let index = 0; index < this.planFuncList.length; index++) {
                for (
                  let indey = 0;
                  indey < this.planFuncList[index].length;
                  indey++
                ) {
                  const element = this.planFuncList[index][indey];
                  if (element.checked) {
                    writeWorks.push(element.value);
                  }
                }
              }
              let photos = [];
              for (let index = 0; index < this.planPhotoList.length; index++) {
                const element = this.planPhotoList[index];
                if (element.checked) {
                  photos.push(element.value);
                }
              }
              let imgs = [];
              for (let index = 0; index < this.planPsList.length; index++) {
                const element = this.planPsList[index];
                if (element.checked) {
                  imgs.push(element.value);
                }
              }
              let planGroupContent = {
                imgs,
                photos,
                types,
                writeWorks,
              };
              params = {
                ...params,
                planGroupContent,
              };
            }

            if (this.form.applyPost == 2) {
              let types = [];
              for (
                let index = 0;
                index < this.serviceTypeList.length;
                index++
              ) {
                const element = this.serviceTypeList[index];
                if (element.checked) {
                  types.push(element.value);
                }
              }
              let workSofts = [];
              for (
                let index = 0;
                index < this.serviceOfficeList.length;
                index++
              ) {
                for (
                  let indey = 0;
                  indey < this.serviceOfficeList[index].length;
                  indey++
                ) {
                  const element = this.serviceOfficeList[index][indey];
                  if (element.checked) {
                    workSofts.push(element.value);
                  }
                }
              }

              let serviceGroupContent = {
                hrExperience: this.form.hrExperience,
                types,
                workSofts,
              };
              params = {
                ...params,
                serviceGroupContent,
              };
            }
            let submit;
            if (this.$route.params.type == "set") {
              submit = this.$api.register;
            } else if (this.$route.params.type == "update") {
              submit = this.$api.editMessage;
              params.id = this.userMess.id;
            }
            submit(params).then((res) => {
              // console.log(res)
              if (res.code == 0) {
                this.$message.error(res.message);
              } else {
                this.$message.success(res.message);
                setTimeout(function () {
                  window.location.href = gl.rzUrl;
                  // let userAgent = navigator.userAgent;
                  // if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
                  //   window.location.href = gl;
                  //   window.close();
                  // } else {
                  //   window.opener = null;
                  //   window.open("", "_self");
                  //   window.close();
                  // }
                }, 2000);
              }
            });
          } else {
            this.$message.error("请先确认信息");
          }
        } else {
          this.$message.error("请完善信息");
        }
      });
    },
    showRule() {
      let routeData = this.$router.resolve({ name: "rule" });
      window.open(routeData.href, "_blank");

      // console.log("ssss")
    },
    getPhoto(val) {
      // console.log(val)
      this.form.photo = val.fileId;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$store.commit("setLoading", false);
    function isNull(val) {
      if (val === "" || val === null) {
        return "";
      } else {
        return val.toString();
      }
    }

    if (this.$route.params.type == "update") {
      this.form = {
        regType: "1",
        // teamName: this.userMess.teamName,
        userName: this.userMess.userName,
        sex: isNull(this.userMess.sex),
        birth: this.userMess.birth,
        nation: this.userMess.nation,
        religion: this.userMess.religion,
        maritalStatus: this.userMess.maritalStatus,
        political: this.userMess.political,
        idCard: this.userMess.idCard,
        idCardType: this.userMess.idCard || "身份证",
        currentStatus: isNull(this.userMess.currentStatus),
        workUnit: this.userMess.workUnit,
        officialCapacity: this.userMess.officialCapacity,
        mainWork: this.userMess.mainWork,
        contactInfo: this.userMess.contactInfo,
        mailbox: this.userMess.mailbox,
        emergencyName: this.userMess.emergencyName,
        emergencyPhone: this.userMess.emergencyPhone,
        mailAddress: this.userMess.mailAddress,
        highestEducation: isNull(this.userMess.highestEducation),
        homeAddress: this.userMess.homeAddress,
        applyPost: isNull(this.userMess.applyPost),
        // firstTime: this.userMess.positiveTime,
        volunteerServiceExperience: this.userMess.volunteerServiceExperience,
        studyAndWorkExperience: this.userMess.studyAndWorkExperience,
        reasonsVolunteerWork: this.userMess.reasonsVolunteerWork,
        // wayText: this.userMess.informationResourceContent,
        photo: this.userMess.photo,
        isResident: this.userMess.isResident,
      };
      this.serviceList = this.userMess.serviceTime.split(",");

      if (this.userMess.applyPost == 1) {
        this.explainLanguageUseList[1].value =
          this.userMess.explainGroupContent.englishLevel;
        this.explainLanguageUseList[0].value =
          this.userMess.explainGroupContent.mandarinLevel;
        this.form.otherKnowledge =
          this.userMess.explainGroupContent.otherKnowledge;
        for (let index = 0; index < this.explainLanguageList.length; index++) {
          const element = this.explainLanguageList[index];
          if (
            this.userMess.explainGroupContent.languages.includes(element.value)
          ) {
            element.checked = true;
          }
        }
        for (let index = 0; index < this.explainTypeList.length; index++) {
          const element = this.explainTypeList[index];
          if (this.userMess.explainGroupContent.types.includes(element.value)) {
            element.checked = true;
          }
        }
      }

      if (this.form.applyPost == 3) {
        let types = [];
        for (let index = 0; index < this.planTypeList.length; index++) {
          const element = this.planTypeList[index];
          if (this.userMess.planGroupContent.types.includes(element.value)) {
            element.checked = true;
          }
        }

        for (let index = 0; index < this.planFuncList.length; index++) {
          for (
            let indey = 0;
            indey < this.planFuncList[index].length;
            indey++
          ) {
            const element = this.planFuncList[index][indey];
            if (
              this.userMess.planGroupContent.writeWorks.includes(element.value)
            ) {
              element.checked = true;
            }
          }
        }
        for (let index = 0; index < this.planPhotoList.length; index++) {
          const element = this.planPhotoList[index];
          if (this.userMess.planGroupContent.photos.includes(element.value)) {
            element.checked = true;
          }
        }
        for (let index = 0; index < this.planPsList.length; index++) {
          const element = this.planPsList[index];
          if (this.userMess.planGroupContent.imgs.includes(element.value)) {
            element.checked = true;
          }
        }
      }

      if (this.form.applyPost == 2) {
        for (let index = 0; index < this.serviceTypeList.length; index++) {
          const element = this.serviceTypeList[index];
          if (this.userMess.serviceGroupContent.types.includes(element.value)) {
            element.checked = true;
          }
        }
        for (let index = 0; index < this.serviceOfficeList.length; index++) {
          for (
            let indey = 0;
            indey < this.serviceOfficeList[index].length;
            indey++
          ) {
            const element = this.serviceOfficeList[index][indey];
            if (
              this.userMess.serviceGroupContent.workSofts.includes(
                element.value
              )
            ) {
              element.checked = true;
            }
          }
        }
      }

      console.log(this.$store.state.user.user);
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.reg-title {
  max-width: 1080px;
  margin: 10px auto 30px;
  padding: 6px 10px;
  background: #f0f8fa;
  color: @bg-green;
  text-align: center;
}

.table-ul {
  display: flex;
  li {
    width: 200px;
    text-align: center;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  li:first-child {
    border-left: 1px solid #e0e0e0;
  }
}
.table-ul:first-child {
  li {
    border-top: 1px solid #e0e0e0;
  }
}
.rule {
  color: @font-blue;
  cursor: pointer;
}
::v-deep .el-form-item__content {
  width: 290px !important;
  .el-select {
    width: 290px !important;
  }
  .el-input {
    width: 290px !important;
  }
}

.form-row {
  ::v-deep .el-form-item {
    width: 100%;
    .el-form-item__content {
      margin-left: 0px !important;
      width: calc(100% - 190px) !important;
    }
  }
}

//改变el-input的宽高

.no-red-form-item {
  /deep/ .is-error {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
    .input__inner:focus {
      border-color: #dcdfe6 !important;
    }
  }
  .select-li {
    /deep/ .el-select {
      width: 200px !important;
      // width: 60%;
      // padding: 5px;
      padding: 0 5px;
      input {
        height: 30px;
      }
    }
    // padding: 5px 5px;
  }
  /deep/ .el-input {
    width: 100% !important;
    padding: 0 !important;
    // padding: 10px;
  }
}
</style>
